/**
 * SFDC Community API
 * # Summary Elisa B2B API for an administrator of a company to query and modify the company information.  # Usage This API is used in the `https://yrityksille.elisa.fi/omaelisa` pages, but it is possible to later on expose this documentation publicly and make the endpoint queryable via external clients.  # Identifiers All entities in the API have a globally unique, internal identifier field named with the format [object_type]Id, e.g. `invoiceId`, which is also used in some of the API endpoint urls, e.g. `/api/v1/selfservice/invoices/{invoiceId}`. This value is not meaningful to the end user but is only used as an internally in the API.  Most entities also have a displayable identifier named in the format [object_type]DisplayId. This value can and should be shown to the end user, as it is also printed in relevant documents. It is also used in some of the public URLs, e.g. `https://yrityksille.elisa.fi/omaelisa/laskut/{invoiceDisplayId}`. Because of the user might land directly into a URL of a single entity with a display id, some of the API endpoints here also support querying via the display id, e.g. `/api/v1/selfservice/invoices?invoiceDisplayId={invoiceDisplayId}`.  The reason for using two identifiers instead of only one display id, is to make sure that every object will always have exactly one REST API URL that will never collide with another. While collisions of display ids should not happen in production, the id fields are guaranteed to be unique even across different test environments. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionActionDetails } from './subscriptionActionDetails.js';


/**
 * Tracking information for an action (change, cancel, create) to a subscription.
 */
export interface SubscriptionAction { 
    /**
     * Internal, unique id of the subscription action, or mass order line item. SFDC: Non_MACD_Subscription_Change_Request__c.Id OR Mass_Order_Line_Item__c.Id
     */
    subscriptionActionId: string;
    /**
     * User-readable id of the subscription action, or mass order line item. SFDC: Non_MACD_Subscription_Change_Request__c.Name OR Mass_Order_Line_Item__c.Name.
     */
    subscriptionActionDisplayId: string;
    /**
     * Internal, unique id of the subscription action group (mass order header record). SFDC: Mass_Order_Request__c.Id.
     */
    subscriptionActionGroupId?: string;
    /**
     * User-readable id of the subscription action group. SFDC: Mass_Order_Request__c.Name.
     */
    subscriptionActionGroupDisplayId?: string;
    /**
     * Type of subscription change. OTHER value is used for internally initiated actions. SFDC: Non_MACD_Subscription_Change_Request__c.RecordTypeId.
     */
    subscriptionActionType: SubscriptionAction.SubscriptionActionTypeEnum;
    /**
     * Internal, unique id of the subscription the action affects. SFDC: Non_MACD_Subscription_Change_Request__c.csord__Subscription__c
     */
    subscriptionId: string;
    /**
     * Status of this subscription change request. SFDC: Non_MACD_Subscription_Change_Request__c.Status__c
     */
    status: SubscriptionAction.StatusEnum;
    details?: SubscriptionActionDetails;
    /**
     * Unix timestamp in milliseconds of creation. SFDC: Non_MACD_Subscription_Change_Request__c.CreatedDate
     */
    created: number;
    /**
     * Unix timestamp of last modification. SFDC: Non_MACD_Subscription_Change_Request__c.LastModifiedDate
     */
    lastModified: number;
    /**
     * List of changed addOn GUIDs. Applicable when subscriptionActionType is CHANGE_FEATURES
     */
    changedFeatures?: Array<string>;
}
export namespace SubscriptionAction {
    export type SubscriptionActionTypeEnum = 'CANCEL' | 'CHANGE_ADDRESS' | 'CHANGE_BILLING_ACCOUNT' | 'CHANGE_CONTACTS' | 'CHANGE_DEVICE' | 'CHANGE_FEATURES' | 'CHANGE_MOBILE_PBX' | 'CHANGE_OFFER' | 'CHANGE_OWNER' | 'CHANGE_SIM' | 'CHANGE_USER_INFORMATION' | 'EPP_REDEEM_TERMINATE' | 'OTHER' | 'RESUME' | 'SUSPEND' | 'TERMINATE_DEVICE_SERVICE' | 'TERMINATE_SUBSCRIPTION' | 'CHANGE_MOBILE_PBX_SOLUTION';
    export const SubscriptionActionTypeEnum = {
        CANCEL: 'CANCEL' as SubscriptionActionTypeEnum,
        CHANGE_ADDRESS: 'CHANGE_ADDRESS' as SubscriptionActionTypeEnum,
        CHANGE_BILLING_ACCOUNT: 'CHANGE_BILLING_ACCOUNT' as SubscriptionActionTypeEnum,
        CHANGE_CONTACTS: 'CHANGE_CONTACTS' as SubscriptionActionTypeEnum,
        CHANGE_DEVICE: 'CHANGE_DEVICE' as SubscriptionActionTypeEnum,
        CHANGE_FEATURES: 'CHANGE_FEATURES' as SubscriptionActionTypeEnum,
        CHANGE_MOBILE_PBX: 'CHANGE_MOBILE_PBX' as SubscriptionActionTypeEnum,
        CHANGE_OFFER: 'CHANGE_OFFER' as SubscriptionActionTypeEnum,
        CHANGE_OWNER: 'CHANGE_OWNER' as SubscriptionActionTypeEnum,
        CHANGE_SIM: 'CHANGE_SIM' as SubscriptionActionTypeEnum,
        CHANGE_USER_INFORMATION: 'CHANGE_USER_INFORMATION' as SubscriptionActionTypeEnum,
        EPP_REDEEM_TERMINATE: 'EPP_REDEEM_TERMINATE' as SubscriptionActionTypeEnum,
        OTHER: 'OTHER' as SubscriptionActionTypeEnum,
        RESUME: 'RESUME' as SubscriptionActionTypeEnum,
        SUSPEND: 'SUSPEND' as SubscriptionActionTypeEnum,
        TERMINATE_DEVICE_SERVICE: 'TERMINATE_DEVICE_SERVICE' as SubscriptionActionTypeEnum,
        TERMINATE_SUBSCRIPTION: 'TERMINATE_SUBSCRIPTION' as SubscriptionActionTypeEnum,
        CHANGE_MOBILE_PBX_SOLUTION: 'CHANGE_MOBILE_PBX_SOLUTION' as SubscriptionActionTypeEnum
    };
    export type StatusEnum = 'PENDING_APPROVAL' | 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'ERROR';
    export const StatusEnum = {
        PENDING_APPROVAL: 'PENDING_APPROVAL' as StatusEnum,
        PENDING: 'PENDING' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        CANCELLED: 'CANCELLED' as StatusEnum,
        ERROR: 'ERROR' as StatusEnum
    };
}


